import { endOfDay, startOfDay } from 'date-fns'
import { useFormContext, useWatch } from 'react-hook-form'

import { TimePeriod } from 'components/reports/Metrics/constants/ExceptionMetrics'
import { ExceptionMetricsInputDtoInput } from 'generated/graphql'
import { resolvePeriod } from 'helpers/metricsPeriod.helpers'

import { ExceptionMetricsFilterValues } from './ExceptionMetricsFilterCriteria'

interface QueryInput {
  start: Date | null
  end: Date | null
  hasValidRange: boolean
  isCustom: boolean
  input: ExceptionMetricsInputDtoInput
}

export const useExceptionMetricsQueryInput = (): QueryInput => {
  const { control } = useFormContext<ExceptionMetricsFilterValues>()
  const period = useWatch({ control, name: 'period' })
  const customStart = useWatch({ control, name: 'customStart' })
  const customEnd = useWatch({ control, name: 'customEnd' })
  const selectedServiceCodes = useWatch({ control, name: 'selectedServiceCodes' })
  const vehicleType = useWatch({ control, name: 'vehicleType' })

  const isCustom = period === ('custom' as TimePeriod)

  const { start, end } = isCustom
    ? {
        start: customStart ? startOfDay(customStart) : null,
        end: customEnd ? endOfDay(customEnd) : null,
      }
    : resolvePeriod(period)

  const hasValidRange = start != null && end != null && start <= end

  return {
    start,
    end,
    hasValidRange,
    isCustom,
    input: {
      start: start ?? new Date(),
      end: end ?? new Date(),
      xeroCodeIds: selectedServiceCodes?.length
        ? selectedServiceCodes.map((option) => option.value)
        : null,
      vehicleType,
    },
  }
}
